module.exports = __webpack_public_path__ + "static/img/cruelty_child_2_sc.741ecf0d.png";